<template>

  <br>
  <br>
  <br>

  <div dir="rtl" class="navbar">

    <router-link :to="{name:'HomePage'}" class="navbar_items">
      <div style="width: fit-content" :class="page === 'HomePage' ? 'bg-white-nav font-color' : 'font-color-white' "
           class="p-2 d-flex justify-content-center align-items-center rounded-circle ">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
             class="bi bi-house "
             viewBox="0 0 16 16">
          <path
              d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
        </svg>
      </div>

      <p class="font-5 m-0 font-color-white text-center">
        خانه
      </p>
    </router-link>

    <!--    <router-link :to="{name:'AddNewAdvertising' , params:{action:'new'}}" class="navbar_items">-->
    <!--      <div style="width: fit-content" :class="page === 'AddNewAdvertising' ? 'bg-white-nav font-color' : 'font-color-white' "-->
    <!--           class="p-2 d-flex justify-content-center align-items-center rounded-circle">-->
    <!--        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"-->
    <!--             class="bi bi-plus text-white " viewBox="0 0 16 16">-->
    <!--          <path-->
    <!--              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>-->
    <!--        </svg>-->
    <!--      </div>-->

    <!--      <p class="font-5 m-0 font-color-white text-center text-nowrap">-->
    <!--        ثبت آگهی-->
    <!--      </p>-->
    <!--    </router-link>-->

    <div @click="check_cart" class="navbar_items">
      <div style="width: fit-content"
           :class="page === 'AddNewAdvertising' ? 'bg-white-nav font-color' : 'font-color-white' "
           class="p-2 d-flex justify-content-center align-items-center rounded-circle">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-bag-check" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
          <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/>
        </svg>
      </div>

      <p class="font-5 m-0 font-color-white text-center text-nowrap">
        سبد خرید
      </p>
    </div>

    <router-link :to="{name:'MyChats'}" class="navbar_items">
      <div style="width: fit-content" :class="page === 'MyChats' ? 'bg-white-nav font-color' : 'font-color-white' "
           class="p-2 d-flex justify-content-center align-items-center rounded-circle">

        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-chat-dots" viewBox="0 0 16 16">
          <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
          <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125m.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6-3.004 6-7 6a8 8 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a11 11 0 0 0 .398-2"/>
        </svg>
      </div>

      <p class="font-5 m-0 font-color-white text-center text-nowrap">
        چت های من
      </p>
    </router-link>

    <router-link :to="{name:'ProfilePage'}" class="navbar_items">
      <div style="width: fit-content" :class="page === 'ProfilePage' ? 'bg-white-nav font-color' : 'font-color-white' "
           class="p-2 d-flex justify-content-center align-items-center rounded-circle">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
             class="bi bi-person " viewBox="0 0 16 16">
          <path
              d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"/>
        </svg>
      </div>

      <p class="font-5 m-0 font-color-white text-center">
        کاربری
      </p>
    </router-link>

  </div>

</template>


<script>


import {ref} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import router from "@/router";
import Swal from "sweetalert2";

export default {

  name: 'BottomNavigation',

  setup() {

    let store = useStore()
    let page = ref('')

    page.value = useRoute().name

    function check_cart() {
      if (store.state.order.products.length === 0){

        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          background: '#38485f',
          color: '#ffffff',
          customClass: "font-5",
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
          hideClass: {
            popup: `
      animate__animated
      animate__fadeOutUp
      animate__faster
    `}
        });
        Toast.fire({
          icon: "warning",
          title: 'محصولی در سبد خرید شما وجود ندارد!'
        })

      }else{
        router.push({name:'OrdersPage'})
      }
    }

    return {
      page,
      check_cart,
    }
  }
}
</script>


<style scoped>

.navbar {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  max-width: 700px;
  border-radius: 25px;
  position: fixed;
  bottom: 0;
  background-color: #818285;
  /*transform: translate(-0.5%, 0);*/
  z-index: 5;
}

.navbar_items {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
}

.bg-white-nav {
  background-color: white;
}

</style>